import React, { useState } from 'react';
import { Bell, Check } from 'lucide-react';

const driverToggleGroups = [
  {
    label: 'Orders & Earnings',
    items: [
      { key: 'newOrders', label: 'New Order Alerts', desc: 'Get notified when new orders are available' },
      { key: 'earningsUpdates', label: 'Earnings Updates', desc: 'Daily earnings summaries and payout alerts' },
      { key: 'promotions', label: 'Promotions & Bonuses', desc: 'Surge pricing, bonus opportunities' },
    ],
  },
  {
    label: 'Delivery Channels',
    items: [
      { key: 'sms', label: 'SMS Alerts', desc: 'Receive alerts via text message' },
      { key: 'email', label: 'Email Notifications', desc: 'Receive alerts via email' },
      { key: 'push', label: 'Push Notifications', desc: 'In-app and browser push alerts' },
    ],
  },
];

const DriverNotificationPreferences = ({ preferences, onSave }) => {
  const [prefs, setPrefs] = useState({
    newOrders: true,
    earningsUpdates: true,
    promotions: true,
    sms: true,
    email: false,
    push: true,
    ...preferences,
  });
  const [saved, setSaved] = useState(false);

  const handleToggle = (key) => {
    setPrefs(prev => ({ ...prev, [key]: !prev?.[key] }));
    setSaved(false);
  };

  const handleSave = async () => {
    try {
      await onSave?.(prefs);
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (err) {
      console.error('Failed to save preferences:', err);
    }
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
      <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Bell className="w-4 h-4 text-[#1a365d]" />
          <h3 className="font-semibold text-[#1a365d]">Notification Preferences</h3>
        </div>
        <button
          onClick={handleSave}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-all ${
            saved ? 'bg-green-100 text-green-700' : 'bg-[#1a365d] text-white hover:bg-[#2d5a87]'
          }`}
        >
          {saved ? <><Check className="w-3.5 h-3.5" /> Saved</> : 'Save'}
        </button>
      </div>
      <div className="p-5 space-y-5">
        {driverToggleGroups?.map(group => (
          <div key={group?.label}>
            <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3">{group?.label}</p>
            <div className="space-y-3">
              {group?.items?.map(({ key, label, desc }) => (
                <div key={key} className="flex items-center justify-between gap-3">
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-slate-800">{label}</p>
                    <p className="text-xs text-slate-500 truncate">{desc}</p>
                  </div>
                  <button
                    onClick={() => handleToggle(key)}
                    className={`relative w-11 h-6 rounded-full transition-colors flex-shrink-0 ${prefs?.[key] ? 'bg-[#1a365d]' : 'bg-slate-200'}`}
                  >
                    <span className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform ${prefs?.[key] ? 'translate-x-5' : 'translate-x-0'}`} />
                  </button>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DriverNotificationPreferences;
